/* Hocking & Hale — storefront behaviour */
(function () {
  'use strict';
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var money = function (cents) {
    return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(cents / 100);
  };
  var $ = function (sel, ctx) { return (ctx || document).querySelector(sel); };
  var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); };

  /* ---------- Hero film: plays scenes in sequence ---------- */
  function initHero(hero) {
    var sets = $$('.hh-hero__media', hero);
    var paused = false;
    var btn = $('.hh-hero__pause', hero);
    function activeSet() {
      return sets.filter(function (s) { return s.offsetParent !== null || getComputedStyle(s).display !== 'none'; })[0] || sets[0];
    }
    function setup(set) {
      var clips = $$('video', set);
      if (!clips.length) return;
      if (reduceMotion) { clips.forEach(function (v) { v.removeAttribute('autoplay'); v.pause(); }); return; }
      var i = 0;
      clips.forEach(function (v, idx) {
        v.muted = true; v.playsInline = true;
        v.addEventListener('ended', function () {
          if (paused) return;
          clips[idx].classList.remove('is-active');
          i = (idx + 1) % clips.length;
          var next = clips[i];
          next.currentTime = 0;
          next.classList.add('is-active');
          var p = next.play(); if (p && p.catch) p.catch(function () {});
        });
      });
      clips[0].classList.add('is-active');
      if (set === activeSet()) {
        clips.forEach(function (v, k) { v.preload = k < 2 ? 'auto' : 'metadata'; });
        var p = clips[0].play(); if (p && p.catch) p.catch(function () {});
      }
      set._clips = clips;
    }
    sets.forEach(setup);
    if (btn) {
      btn.addEventListener('click', function () {
        var set = activeSet(); if (!set || !set._clips) return;
        var cur = set._clips.filter(function (v) { return v.classList.contains('is-active'); })[0];
        paused = !paused;
        btn.setAttribute('aria-pressed', paused ? 'true' : 'false');
        btn.setAttribute('aria-label', paused ? 'Play video' : 'Pause video');
        btn.innerHTML = paused
          ? '<svg viewBox="0 0 12 12" aria-hidden="true"><path d="M2 1l9 5-9 5z" fill="currentColor"/></svg>'
          : '<svg viewBox="0 0 12 12" aria-hidden="true"><path d="M2 1h3v10H2zM7 1h3v10H7z" fill="currentColor"/></svg>';
        if (cur) { if (paused) cur.pause(); else { var p = cur.play(); if (p && p.catch) p.catch(function () {}); } }
      });
    }
  }

  /* ---------- Horizontal strips ---------- */
  function initStrips() {
    $$('[data-hh-strip-nav]').forEach(function (nav) {
      var strip = document.getElementById(nav.getAttribute('data-hh-strip-nav'));
      if (!strip) return;
      $$('button', nav).forEach(function (b) {
        b.addEventListener('click', function () {
          var dir = b.getAttribute('data-dir') === 'prev' ? -1 : 1;
          strip.scrollBy({ left: dir * strip.clientWidth * 0.8, behavior: reduceMotion ? 'auto' : 'smooth' });
        });
      });
    });
  }

  /* ---------- Lightbox for review media ---------- */
  function initLightbox() {
    var box = document.createElement('div');
    box.className = 'hh-lightbox';
    box.setAttribute('role', 'dialog');
    box.setAttribute('aria-modal', 'true');
    box.setAttribute('aria-label', 'Customer photo');
    box.innerHTML = '<button class="hh-lightbox__close" type="button" aria-label="Close">&times;</button><div class="hh-lightbox__body"></div>';
    document.body.appendChild(box);
    var body = $('.hh-lightbox__body', box);
    var last = null;
    function close() { box.classList.remove('is-open'); body.innerHTML = ''; document.body.classList.remove('hh-lock'); if (last) last.focus(); }
    box.addEventListener('click', function (e) { if (e.target === box || e.target.classList.contains('hh-lightbox__close')) close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && box.classList.contains('is-open')) close(); });
    document.addEventListener('click', function (e) {
      var t = e.target.closest('[data-hh-media]');
      if (!t) return;
      e.preventDefault();
      last = t;
      var src = t.getAttribute('data-hh-media');
      var alt = t.getAttribute('data-alt') || '';
      body.innerHTML = /\.mp4/.test(src)
        ? '<video src="' + src + '" controls autoplay playsinline muted></video>'
        : '<img src="' + src + '" alt="' + alt.replace(/"/g, '&quot;') + '">';
      box.classList.add('is-open');
      document.body.classList.add('hh-lock');
      $('.hh-lightbox__close', box).focus();
    });
  }

  /* ---------- Delivery estimate ---------- */
  function addBusinessDays(date, n) {
    var d = new Date(date.getTime());
    while (n > 0) { d.setDate(d.getDate() + 1); var w = d.getDay(); if (w !== 0 && w !== 6) n--; }
    return d;
  }
  function initDelivery() {
    $$('[data-hh-delivery]').forEach(function (el) {
      var now = new Date();
      var fmt = { weekday: 'short', month: 'short', day: 'numeric' };
      var from = addBusinessDays(now, 4).toLocaleDateString('en-US', fmt);
      var to = addBusinessDays(now, 9).toLocaleDateString('en-US', fmt);
      el.textContent = from + ' – ' + to;
    });
  }

  /* ---------- Product data helpers ---------- */
  function productData() {
    var s = document.getElementById('hh-product-json');
    if (!s) return null;
    try { return JSON.parse(s.textContent); } catch (e) { return null; }
  }
  function optionWrap(names) {
    var wraps = $$('.variant-input-wrap[data-handle]');
    return wraps.filter(function (w) { return names.indexOf((w.getAttribute('data-handle') || '').toLowerCase()) > -1; })[0] || null;
  }
  var COLOR_NAMES = ['color', 'colour', 'farbe', 'colors'];
  var SIZE_NAMES = ['size', 'grosse', 'groesse', 'größe', 'sizes', 'shoe-size', 'us-size'];

  /* ---------- Image swatches for the color option ---------- */
  function initSwatches() {
    var data = productData();
    if (!data) return;
    if ($('[class*="starapps"], .swatch-view, [data-starapps-swatch]')) return; // swatch app already renders tiles
    var wrap = optionWrap(COLOR_NAMES);
    if (!wrap) return;
    var optIndex = parseInt((wrap.getAttribute('data-index') || 'option1').replace('option', ''), 10) - 1;
    var inputs = $$('input[type=radio]', wrap);
    if (inputs.length < 1) return;
    var box = document.createElement('div');
    box.className = 'hh-swatches';
    box.setAttribute('role', 'group');
    box.setAttribute('aria-label', 'Color');
    inputs.forEach(function (input) {
      var value = input.value;
      var variant = data.variants.filter(function (v) { return v.options[optIndex] === value && v.featured_image; })[0];
      var src = variant && variant.featured_image ? variant.featured_image.src : (data.featured_image || '');
      if (src) src = src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=160';
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'hh-swatch';
      b.setAttribute('aria-pressed', input.checked ? 'true' : 'false');
      b.setAttribute('aria-label', value);
      b.innerHTML = (src ? '<img class="hh-swatch__img" src="' + src + '" alt="" loading="lazy">' : '<span class="hh-swatch__img"></span>') +
        '<span class="hh-swatch__name">' + value.replace(/</g, '&lt;') + '</span>';
      b.addEventListener('click', function () {
        var label = wrap.querySelector('label[for="' + input.id + '"]');
        if (label) label.click(); else { input.checked = true; input.dispatchEvent(new Event('change', { bubbles: true })); }
        sync();
      });
      box.appendChild(b);
    });
    function sync() {
      var btns = $$('.hh-swatch', box);
      inputs.forEach(function (inp, i) { if (btns[i]) btns[i].setAttribute('aria-pressed', inp.checked ? 'true' : 'false'); });
    }
    wrap.addEventListener('change', sync);
    wrap.parentNode.insertBefore(box, wrap);
    wrap.classList.add('hh-swatch-source');
  }

  /* ---------- Size assistant ---------- */
  var ALPHA = ['XXS', 'XS', 'S', 'M', 'L', 'XL', 'XXL', '3XL', '4XL'];
  function normalizeAlpha(v) {
    var s = String(v).toUpperCase().replace(/\s+/g, '');
    if (s === '2XL') return 'XXL';
    if (s === 'XXXL') return '3XL';
    return s;
  }
  function initSizeAssistant() {
    var modal = document.getElementById('hh-size-modal');
    if (!modal) return;
    var data = productData() || { tags: [], options: [], variants: [] };
    var tags = (data.tags || []).map(function (t) { return String(t).toUpperCase(); });
    var has = function (prefix) { return tags.some(function (t) { return t.indexOf(prefix) === 0; }); };
    var isMen = tags.indexOf('MEN') > -1 || has('MEN-');
    var kind = (has('SHOE') || has('MEN-SHOE')) ? 'shoe'
      : (has('CLO-OUT') || has('MEN-OUT')) ? 'outer'
      : (has('CLO-DRESS') || has('CLO-SET')) ? 'dress'
      : (has('CLO-BOT') || has('MEN-BOT')) ? 'bottom' : 'top';
    modal.setAttribute('data-kind', kind);
    var flow = $('[data-flow="' + (kind === 'shoe' ? 'shoe' : 'apparel') + '"]', modal);
    $$('[data-flow]', modal).forEach(function (f) { f.hidden = f !== flow; });
    var questions = $$('.hh-q', flow);
    var steps = $$('.hh-steps span', modal);
    var state = { unit: 'us', build: 'average', fit: 'true', width: 'regular', between: 'up' };
    var step = 0;
    var lastFocus = null;

    // Category-specific wording
    var buildQ = $('[data-q="build"] legend', flow);
    if (buildQ) {
      buildQ.textContent = kind === 'bottom' ? 'How would you describe your hips and thighs?'
        : kind === 'dress' ? 'How would you describe your figure?'
        : isMen ? 'How would you describe your build?' : 'How would you describe your upper body?';
    }
    var fitQ = $('[data-q="fit"] legend', flow);
    if (fitQ) {
      fitQ.textContent = kind === 'outer' ? 'How do you like your coats and jackets to fit?'
        : kind === 'dress' ? 'How do you like your dresses to fit?'
        : kind === 'bottom' ? 'How do you like your trousers to fit?' : 'How do you like your tops and knitwear to fit?';
    }
    var outerHint = $('[data-outer-hint]', flow);
    if (outerHint) outerHint.hidden = kind !== 'outer';

    function show(i) {
      step = i;
      questions.forEach(function (q, idx) { q.classList.toggle('is-active', idx === i); });
      steps.forEach(function (s, idx) { s.classList.toggle('is-done', idx <= i); });
      var first = questions[i] && questions[i].querySelector('input, select, button.hh-opt');
      if (first) setTimeout(function () { first.focus(); }, 30);
    }
    function open(e) {
      if (e) e.preventDefault();
      lastFocus = document.activeElement;
      modal.classList.add('is-open');
      document.body.classList.add('hh-lock');
      show(0);
    }
    function close() {
      modal.classList.remove('is-open');
      document.body.classList.remove('hh-lock');
      if (lastFocus) lastFocus.focus();
    }
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-hh-size-open]')) open(e);
      if (e.target.closest('[data-hh-size-close]')) close();
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && modal.classList.contains('is-open')) close(); });

    // unit toggle
    $$('[data-unit]', flow).forEach(function (b) {
      b.addEventListener('click', function () {
        state.unit = b.getAttribute('data-unit');
        $$('[data-unit]', flow).forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
        $$('[data-units]', flow).forEach(function (g) { g.hidden = g.getAttribute('data-units') !== state.unit; });
      });
    });
    // single-choice options
    $$('.hh-options', modal).forEach(function (group) {
      var key = group.getAttribute('data-key');
      $$('.hh-opt', group).forEach(function (b) {
        b.addEventListener('click', function () {
          state[key] = b.getAttribute('data-value');
          $$('.hh-opt', group).forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
        });
      });
    });
    $$('[data-next]', modal).forEach(function (b) {
      b.addEventListener('click', function () {
        var q = questions[step];
        var err = q && q.querySelector('.hh-error');
        if (q && q.getAttribute('data-q') === 'body') {
          var h, w;
          if (state.unit === 'us') {
            var ft = parseFloat($('[name=hh_ft]', q).value), inch = parseFloat($('[name=hh_in]', q).value || '0');
            var lb = parseFloat($('[name=hh_lb]', q).value);
            h = (ft * 12 + inch) * 2.54; w = lb * 0.4536;
          } else {
            h = parseFloat($('[name=hh_cm]', q).value); w = parseFloat($('[name=hh_kg]', q).value);
          }
          if (!(h > 130 && h < 220) || !(w > 35 && w < 200)) {
            if (err) err.textContent = 'Enter your height and weight to continue.';
            return;
          }
          if (err) err.textContent = '';
          state.h = h; state.w = w;
        }
        if (q && q.getAttribute('data-q') === 'usual') {
          var us = parseFloat($('[name=hh_us]', q).value);
          if (!(us >= 4 && us <= 15)) { if (err) err.textContent = 'Choose your usual US shoe size to continue.'; return; }
          if (err) err.textContent = '';
          state.us = us;
        }
        if (step + 1 < questions.length - 1) { show(step + 1); } else { result(); show(questions.length - 1); }
      });
    });
    $$('[data-back]', modal).forEach(function (b) { b.addEventListener('click', function () { show(Math.max(0, step - 1)); }); });

    var sizeWrap = optionWrap(SIZE_NAMES) || (function () {
      var color = optionWrap(COLOR_NAMES);
      return $$('.variant-input-wrap[data-handle]').filter(function (w) { return w !== color; })[0] || null;
    })();
    var available = sizeWrap ? $$('input[type=radio]', sizeWrap).map(function (i) { return i.value; }) : [];

    function pickApparel() {
      var bmi = state.w / Math.pow(state.h / 100, 2);
      var bmiIdx = bmi < 18.5 ? 1 : bmi < 21 ? 2 : bmi < 23.5 ? 3 : bmi < 26.5 ? 4 : bmi < 30 ? 5 : bmi < 34 ? 6 : 7;
      var kg = state.w - (isMen ? 14 : 0);
      var wIdx = kg < 50 ? 1 : kg < 58 ? 2 : kg < 67 ? 3 : kg < 77 ? 4 : kg < 88 ? 5 : kg < 100 ? 6 : 7;
      var score = (bmiIdx + wIdx) / 2;
      score += { slim: -0.5, average: 0, curvy: 0.5 }[state.build] || 0;
      score += { fitted: -0.35, 'true': 0, relaxed: 0.5 }[state.fit] || 0;
      if (kind === 'outer') score += 0.3;
      if (kind === 'bottom' && state.build === 'curvy') score += 0.2;
      if (isMen) score += 0.4;
      var idx = Math.max(1, Math.min(7, Math.round(score)));
      var wanted = ALPHA[idx];
      if (!available.length) return { size: wanted, value: null };
      var alphaAvail = available.filter(function (v) { return ALPHA.indexOf(normalizeAlpha(v)) > -1; });
      if (alphaAvail.length) {
        var best = alphaAvail.reduce(function (acc, v) {
          var d = Math.abs(ALPHA.indexOf(normalizeAlpha(v)) - idx);
          return !acc || d < acc.d ? { v: v, d: d } : acc;
        }, null);
        return { size: best.v, value: best.v };
      }
      // numeric sizes: map the index across the available range
      var nums = available.slice();
      var pos = Math.round(((idx - 1) / 6) * (nums.length - 1));
      return { size: nums[pos], value: nums[pos] };
    }
    function pickShoe() {
      var us = state.us;
      if (state.width === 'wide') us += 0.5;
      if (state.between === 'up' && us % 1 !== 0 && !available.some(function (v) { return parseFloat(v) === us; })) us = Math.ceil(us);
      if (state.between === 'down' && us % 1 !== 0 && !available.some(function (v) { return parseFloat(v) === us; })) us = Math.floor(us);
      if (!available.length) return { size: 'US ' + us, value: null };
      var nums = available.map(function (v) { return { v: v, n: parseFloat(String(v).replace(',', '.').replace(/[^0-9.]/g, '')) }; }).filter(function (x) { return !isNaN(x.n); });
      if (!nums.length) return { size: 'US ' + us, value: null };
      var isEU = nums[0].n >= 30;
      var target = isEU ? (isMen ? us + 33 : us + 31) : us;
      var best = nums.reduce(function (acc, x) { var d = Math.abs(x.n - target); return !acc || d < acc.d ? { v: x.v, d: d } : acc; }, null);
      return { size: best.v, value: best.v, note: isEU ? ('Equivalent to about US ' + us) : '' };
    }
    function result() {
      var r = kind === 'shoe' ? pickShoe() : pickApparel();
      state.result = r;
      var out = $('.hh-result', modal.querySelector('[data-flow]:not([hidden])'));
      $('.hh-result__size', out).textContent = r.size;
      var note = kind === 'shoe'
        ? (r.note ? r.note + '. ' : '') + (state.width === 'wide' ? 'We went half a size up for a wider foot.' : 'Based on your usual size and fit preference.')
        : 'Based on your height, weight' + (kind === 'outer' ? ', room for layering' : '') + ' and how you like things to fit.';
      $('.hh-result__note', out).textContent = note;
      var add = $('[data-hh-add]', out);
      if (add) {
        add.hidden = !r.value;
        add.textContent = 'Add size ' + r.size + ' to cart';
      }
    }
    $$('[data-hh-add]', modal).forEach(function (b) {
      b.addEventListener('click', function () {
        if (!state.result || !sizeWrap) return;
        var input = $$('input[type=radio]', sizeWrap).filter(function (i) { return i.value === state.result.value; })[0];
        if (input) {
          var label = sizeWrap.querySelector('label[for="' + input.id + '"]');
          if (label) label.click(); else { input.checked = true; input.dispatchEvent(new Event('change', { bubbles: true })); }
        }
        close();
        setTimeout(function () {
          var atc = $('form[action*="/cart/add"] [type=submit][name=add], form[action*="/cart/add"] .add-to-cart, form[action*="/cart/add"] button[type=submit]');
          if (atc && !atc.disabled) atc.click();
        }, 250);
      });
    });
  }

  /* ---------- Cart drawer: bundle tiers ---------- */
  var TIERS = [{ n: 2, p: 10 }, { n: 3, p: 15 }, { n: 4, p: 20 }];
  function renderTiers(count) {
    var box = document.getElementById('hh-tier');
    if (!box) return;
    var fill = $('.hh-tier__fill', box);
    var msg = $('.hh-tier__msg', box);
    fill.style.width = Math.min(count / 4, 1) * 100 + '%';
    $$('.hh-tier__node', box).forEach(function (n) { n.classList.toggle('is-reached', count >= parseInt(n.getAttribute('data-n'), 10)); });
    var next = TIERS.filter(function (t) { return count < t.n; })[0];
    var reached = TIERS.filter(function (t) { return count >= t.n; }).pop();
    if (!count) { msg.innerHTML = 'Bundle &amp; save: <strong>10% off 2 items</strong>, 15% off 3, 20% off 4 or more.'; return; }
    if (next) {
      var diff = next.n - count;
      msg.innerHTML = (reached ? 'You are saving <strong>' + reached.p + '%</strong>. ' : '') +
        'Add ' + diff + ' more item' + (diff > 1 ? 's' : '') + ' to save <strong>' + next.p + '%</strong> on your order.';
    } else {
      msg.innerHTML = 'You unlocked our best offer: <strong>20% off</strong> your order, applied at checkout.';
    }
  }
  function refreshCart() {
    fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (c) {
      renderTiers(c.item_count);
      var sub = $('#CartDrawer [data-subtotal]');
      if (sub) sub.textContent = money(c.total_price);
    }).catch(function () {});
  }
  function initCart() {
    var box = document.getElementById('hh-tier');
    if (!box) return;
    renderTiers(parseInt(box.getAttribute('data-count'), 10) || 0);
    document.addEventListener('cart:updated', function (e) {
      if (e.detail && e.detail.cart) renderTiers(e.detail.cart.item_count); else refreshCart();
    });
    document.addEventListener('ajaxProduct:added', refreshCart);
    document.addEventListener('cart:build', function () { setTimeout(refreshCart, 300); });
    var products = $('#CartDrawer [data-products]');
    if (products && window.MutationObserver) new MutationObserver(function () { refreshCart(); }).observe(products, { childList: true });
  }

  function init() {
    $$('.hh-hero').forEach(initHero);
    initStrips();
    initLightbox();
    initDelivery();
    initSwatches();
    initSizeAssistant();
    initCart();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', function () { $$('.hh-hero').forEach(initHero); initStrips(); initDelivery(); });
})();
